import { render, staticRenderFns } from "./register2.vue?vue&type=template&id=06dfc559&scoped=true&"
import script from "./register2.vue?vue&type=script&lang=js&"
export * from "./register2.vue?vue&type=script&lang=js&"
import style0 from "./register2.vue?vue&type=style&index=0&id=06dfc559&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dfc559",
  null
  
)

export default component.exports